import { Box, Alert } from "@mui/material";
import React from "react";

interface WarningBoxProps {
  children: React.ReactNode;
}

export const WarningBox: React.FC<WarningBoxProps> = ({ children }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="warning" sx={{ borderRadius: 1 }}>
        {children}
      </Alert>
    </Box>
  );
};
